import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper';
export const priorityMoscowApi = createApi({
  reducerPath: 'priorityMoscowApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/priority` }),
  tagTypes: ['priorityMoscow'],
  refetchOnFocus: true,
  endpoints: (build) => ({
    fetchAllPriorityMoscow: build.query({
      query: () => ({
        url: '/priority-moscow'
      }),

      providesTags: (result) =>
        result
          ? [
              ...result.priorityMoscow.map(({ _id }) => ({ type: 'priorityMoscow', id: _id })), // Provide individual tags for each item
              { type: 'priorityMoscow', id: 'LIST' } // Special tag for the whole list
            ]
          : [{ type: 'priorityMoscow', id: 'LIST' }]
    }),
    addPriorityMoscow: build.mutation({
      query: (newRow) => ({
        url: '/priority-moscow',
        method: 'POST',
        body: newRow
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityMoscowApi.util.updateQueryData('fetchAllPriorityMoscow', undefined, (draft) => {
            draft.priorityMoscow.push(newRow); // Optimistically add the new row to the list
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic addition on failure
        }
      },
      invalidatesTags: [{ type: 'priorityMoscow', id: 'LIST' }]
    }),
    updatePriorityMoscow: build.mutation({
      query: (updatedRow) => ({
        url: `priority-moscow/${updatedRow._id}`,
        method: 'PUT',
        body: updatedRow
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityMoscowApi.util.updateQueryData('fetchAllPriorityMoscow', undefined, (draft) => {
            const item = draft.priorityMoscow.find((row) => row._id === updatedRow._id);
            if (item) {
              Object.assign(item, updatedRow); // Apply changes optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => {
        return [
          { type: 'priorityMoscow', id: updatedRow._id },
          { type: 'priorityMoscow', id: 'LIST' }
        ];
      }
    }),
    addLogEntry: build.mutation({
      query: ({ orderId, ...log }) => ({
        url: `/logbook/${orderId}/add`,
        method: 'POST',
        body: log
      })
    }),
    deletePriorityMoscow: build.mutation({
      query: (id) => ({
        url: `priority-moscow/${id}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityMoscowApi.util.updateQueryData('fetchAllPriorityMoscow', undefined, (draft) => {
            const index = draft.priorityMoscow.findIndex((row) => row._id === id);
            if (index !== -1) {
              draft.priorityMoscow.splice(index, 1); // Remove item optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      },
      invalidatesTags: (result, error, id) => [
        { type: 'priorityMoscow', id },
        { type: 'priorityMoscow', id: 'LIST' }
      ]
    }),
    getLogsByOrderId: build.query({
      query: (orderId) => ({
        url: `/logbook/${orderId}`,
        method: 'GET'
      })
    })
  })
});
